import React, { Component } from 'react';
import {
  Table,
  Button
} from 'reactstrap';

class DemoAutoTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      layer: 1
    };
  }

  decrementLayer() {
    const { layer } = this.state;

    if(layer > 1) this.setState({ layer: layer - 1 });
  }

  incrementLayer() {
    const { layer } = this.state;

    if(layer < 3) this.setState({ layer: layer + 1 });
  }

  render() {
    const { layer } = this.state;

    const headers = DemoAutoHeaders[layer - 1].map((header, i) => {
      return <th key={i}>{header}</th>;
    });

    const data = DemoAutoData[layer - 1].map((row, i) => {
      let bold = false;

      const layerTitlesToBold = ["Toyota", "FAW-Toyota", "Guangzhou-Toyota", "Imports"];
      if((layer === 2 || layer === 3) && layerTitlesToBold.includes(row[0])) bold = true;

      const items = row.map((item, i) => {
        if(bold)
          return <td key={i}><strong>{item}</strong></td>
        else
          return <td key={i}>{item}</td>;
      });

      return <tr key={i}>{items}</tr>;
    });

    return (
      <div>
        <div className="d-flex mb-2">
          <TableHeader layer={layer} />
          <Button
            className="ml-2"
            color="secondary"
            onClick={this.decrementLayer.bind(this)}
            disabled={layer === 1}>
            Go Back
          </Button>
        </div>
        <Table bordered onClick={this.incrementLayer.bind(this)}>
          <thead className="bg-secondary text-white">
            <tr>
              { headers }
            </tr>
          </thead>
          <tbody>
            { data }
          </tbody>
        </Table>
        <Button
          color="secondary"
          onClick={this.decrementLayer.bind(this)}
          disabled={layer === 1}>
          Go Back
        </Button>
      </div>
    );
  }
}

function TableHeader({ layer }) {
  const labels = ["Makes", "Makes/Models/Distributers", "Toyota Models"];

  return <h4>Level {layer}: {labels[layer - 1]}</h4>;
}

const DemoAutoHeaders = [
  [ "Make", "Tianjin", "MPV", "SUV", "Sedans", "Cross-Over" ],
  [ "Make",	"Tianjin", "MPV",	"SUV", "Sedans" ],
  [ "Make", "Core Districts", "Suburbs", "Economic Development", "Surrounding Areas" ]
];

const DemoAutoData = [[
  [ "Volkswagen",	446667,	5600,	27234,	413833,	0 ],
  [ "Audi",	66116, 0, 16518,	49598,	0 ],
  [ "Skoda", 26963,	0,	1848,	25115,	0 ],
  [ "Toyota",	230899,	4801,	55853,	170245,	0 ],
  [ "Hyundai", 91230,	0,	19183,	72047,	0 ],
  [ "Greatwall",	76356,	198,	47498,	28660,	0 ],
  [ "Chang'an",	79503,	6727,	16685,	34535,	21556 ],
  [ "General Motors",	137541,	19727,	13655,	104159,	0 ],
  [ "Cadilac",	6112,	0,	1726,	4386,	0 ],
  [ "SAIC",	24345,	0,	6068,	18277,	0 ],
  [ "Xiali",	96117,	0,	0,	96117,	0 ],
  [ "Porshe",	7039,	0,	5454,	1585,	0 ],
  [ "BMW",	29756,	96,	12810,	16850,	0 ],
], [
  [ "Toyota",	230899,	4801,	55853,	170245 ],
  [ "FAW-Toyota",	148654,	0,	23825,	124829 ],
  [ "Rav 4",	11867, 0,	11867, 0 ],
  [ "Prado",	8793, 0, 8793, 0 ],
  [ "Land Cruiser",	2902, 0, 2902, 0 ],
  [ "Takizawa",	263, 0,	263, 0 ],
  [ "Corolla",	89204, 0, 0, 89204 ],
  [ "Vios",	18118, 0 , 0, 18118 ],
  [ "Crown",	9693, 0, 0,	9693 ],
  [ "Reiz",	7489, 0, 0,	7489 ],
  [ "Prius",	325, 0, 0, 325 ],
  [ "Guangzhou-Toyota",	60941,	1170,	14889,	44882 ],
  [ "Tulan",	1170,	1170, 0, 0 ],
  [ "Highlander",	14889, 0,	14889, 0 ],
  [ "Camry",	24702, 0, 0, 24702 ],
  [ "Ralink",	13554, 0, 0, 13554 ],
  [ "Dazzle",	3470, 0, 0,	3470 ],
  [ "Yaris", 2270, 0, 0, 2270 ],
  [ "Enjoy", 886, 0, 0,	886 ],
  [ "Imports", 21304,	3631,	17139,	534 ],
  [ "Senna", 1944,	1944, 0, 0 ],
  [ "Elfa",	1064,	1064, 0, 0 ],
  [ "Previa",	623,	623, 0, 0 ],
  [ "Prado",	9796, 0, 9796, 0 ],
  [ "Land Cruiser",	6705, 0, 6705, 0 ],
  [ "Fj Cool Road",	537, 0,	537, 0 ],
  [ "Rav 4", 87, 0,	87, 0 ],
  [ "4 Runner",	14, 0, 14, 0 ],
  [ "Camry",	534, 0, 0, 534 ]
], [
  [ "Toyota",25007,7695,7902,14962 ],
  [ "FAW-Toyota",10693,3688,3246,6005 ],
  [ "Rav 4",5858,2420,1776,1630 ],
  [ "Prado",3566,965,1111,3141 ],
  [ "Land Cruiser",1163,202,332,1205 ],
  [ "Takizawa",106,101,27,29 ],
  [ "Guangzhou-Toyota",7205,2169,2252,3262 ],
  [ "Highlander",7205,2169,2252,3262 ],
  [ "Imports",7109,1838,2404,5695 ],
  [ "Prado",4057,1095,1514,3130 ],
  [ "Land Cruiser",2702,658,850,2495 ],
  [ "Fj Cool Road",350,85,40,70 ],
  [ "Rav 4",0,0,0,0 ],
  [ "4 Runner",0,0,0,0 ],
]];




export default DemoAutoTable;
